<ng-container *ngIf="fields">
    <app-field-list (onBack)="handleBack()" (onRowEdit)="handleRowEdit( $event )" [fields]="fields"></app-field-list>
</ng-container>